module.exports = __webpack_public_path__ + "img/img-p.b33bf72b.jpg";